import customAxios from "./axiosConfig";

const HeroesService = {
  list (params) {
    var api_url = window.Urls['promocode-list']();
    return customAxios.get(api_url, {params: params});
  }
};

export default HeroesService;